// extracted by mini-css-extract-plugin
export default {"ToolBar":"suit_ToolBar__KHqKR"};